"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerPDFRendererControls = exports.PDFRendererControls = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@onviobr/element");

var _i18n = _interopRequireDefault(require("./i18n"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      <style>\n        :host {\n          display: flex;\n          align-items: center;\n          justify-content: space-around;\n          height: 48px;\n          min-width: 288px;\n          border-radius: 8px;\n          background-color: rgba(0, 0, 0, .6);\n          color: #FFFFFF;\n          font-family: \"Helvetica Neue\", Arial, sans-serif;\n          font-size: 14px;\n          justify-content: space-around;\n          user-select: none;\n        }\n        :host > div {\n          display: flex;\n          align-items: center;\n        }\n        .zoom .action,\n        .page .action {\n          cursor: pointer;\n        }\n        .separator {\n          box-sizing: border-box;\n          height: 20px;\n          width: 2px;\n          border: 2px solid #FFFFFF;\n          opacity: 0.5;\n        }\n        .action {\n          background: transparent;\n          border: none;\n          outline: none;\n          color: #ffffff;\n        }\n        .page .action {\n          transform: scale(.75);\n        }\n      </style>\n      <div class=\"page\">\n        <button @click=\"", "\"\n                class=\"action\"\n                data-qe-id=\"pdf-renderer-prev-page\">\n          <svg height=\"32\" width=\"32\" viewBox=\"0 0 32 32\" class=\"icon icon-chevron-top\" viewBox=\"0 0 32 32\" aria-hidden=\"true\">\n            <path d=\"M15.997 13.374l-7.081 7.081L7 18.54l8.997-8.998 9.003 9-1.916 1.916z\" fill=\"#ffffff\"/>\n          </svg>\n        </button>\n        <span class=\"pager\">\n          ", " ", " / ", "\n        </span>\n        <button @click=\"", "\"\n                class=\"action\"\n                data-qe-id=\"pdf-renderer-next-page\">\n          <svg height=\"32\" width=\"32\" viewBox=\"0 0 32 32\" viewBox=\"0 0 32 32\" aria-hidden=\"true\">\n            <path d=\"M16.003 18.626l7.081-7.081L25 13.46l-8.997 8.998-9.003-9 1.917-1.916z\" fill=\"#ffffff\"/>\n          </svg>\n        </button>\n      </div>\n      <div class=\"separator\"></div>\n      <div class=\"zoom\">\n        <button\n          @click=\"", "\"\n          class=\"action\"\n          data-qe-id=\"pdf-renderer-zoom-out\"\n          ?disabled=\"", "\">\n          <svg fill=\"#FFFFFF\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M0 0h24v24H0V0z\" fill=\"none\"/>\n            <path d=\"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z\"/>\n          </svg>\n        </button>\n        <span>", "%</span>\n        <button\n          @click=\"", "\"\n          class=\"action\"\n          data-qe-id=\"pdf-renderer-zoom-in\"\n          ?disabled=\"", "\">\n          <svg fill=\"#FFFFFF\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"/>\n            <path d=\"M0 0h24v24H0V0z\" fill=\"none\"/>\n            <path d=\"M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z\"/>\n          </svg>\n        </button>\n      </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PDFRendererControls = /*#__PURE__*/function (_i18nMixin) {
  (0, _inherits2.default)(PDFRendererControls, _i18nMixin);

  var _super = (0, _createSuper2.default)(PDFRendererControls);

  function PDFRendererControls() {
    (0, _classCallCheck2.default)(this, PDFRendererControls);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PDFRendererControls, [{
    key: "zoomIn",
    value: function zoomIn() {
      this.dispatchEvent(new CustomEvent('zoom-in'));
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      this.dispatchEvent(new CustomEvent('zoom-out'));
    }
  }, {
    key: "prevPage",
    value: function prevPage() {
      this.dispatchEvent(new CustomEvent('prev-page'));
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      this.dispatchEvent(new CustomEvent('next-page'));
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject(), this.prevPage, this.i18n('page'), this.current, this.total, this.nextPage, this.zoomOut, this.minZoom > this.zoom - this.zoomScale, (this.zoom * 100).toFixed(0), this.zoomIn, this.maxZoom < this.zoom + this.zoomScale);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'pdf-renderer-controls';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        current: {
          type: Number,
          attribute: true,
          reflect: true
        },
        total: {
          type: Number,
          attribute: true,
          reflect: true
        },
        zoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        minZoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        maxZoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        zoomScale: {
          type: Number,
          attribute: true,
          reflect: true
        }
      };
    }
  }]);
  return PDFRendererControls;
}((0, _element.i18nMixin)(_element.BlueElement));

exports.PDFRendererControls = PDFRendererControls;

var registerPDFRendererControls = function registerPDFRendererControls() {
  (0, _i18n.default)();
  (0, _element.register)(PDFRendererControls);
};

exports.registerPDFRendererControls = registerPDFRendererControls;
